(function (upp, angular) {
    'use strict';

    CustomerFieldsController.$inject = [ '$scope' ];
    function CustomerFieldsController($scope) {
        /**
         * Fields provided via component attribute.
         * @type {Rx.Observable<CustomerField[]>}
         */
        var fields$ = new Rx.Observable(function(subscription) {
            var next = function(val) { subscription.next(angular.copy(val)) };
            if ($scope['fields'])
                next($scope['fields'])
            return $scope.$watch('fields', next);
        });

        /**
         * Field values provided via component attribute.
         * @type {Rx.Observable<CustomerFieldValue[]>}
         */
        var values$ = new Rx.Observable(function(subscription) {
            var next = function(val) { subscription.next(angular.copy(val)) };
            if ($scope['values'])
                next($scope['values'])
            return $scope.$watch('values', next);
        });

        /**
         * Map of field.id -> CustomerFieldValue. The values emitted by this observable
         * will always be a full dicctionary of available fields. This means that even
         * if no CustomerFieldValue for a given field id it will have a CustomerFieldValue
         * object defaulted.
         *
         * @type {Rx.Observable<Object<number,CustomerFieldValue>>}
         */
        var valuesById$ = new Rx.Observable.combineLatest(fields$, values$, function(fields, values) {
            fields = fields || [];
            values = values || [];
            return fields.reduce(function(map, field) {
                // Find the value object
                var value = values.find(function(value) { return value.id === field.id });
                // If no value object, initialize an empty one
                if (!value) {
                    value = {
                        id: field.id,
                        value: null,
                        optionSelected: -1,
                    }
                }
                map[field.id] = value;
                return map;
            }, {});
        });

        Object.defineProperties(this, {
            fields$: { value: fields$, enumerable: true },
            valuesById$: { value: valuesById$, enumerable: true, writable: true },
            readonly: { get: function() { return $scope.readonly }, enumerable: true },
            onChange: { get: function() { return $scope.onChange || angular.noop }, enumerable: true },
        });
    }

    CustomerFieldsController.prototype.notifyChanges = function(valuesById) {
        this.onChange({ $event: Object.values(valuesById) });
    }

    CustomerFieldsController.prototype.inputTypeFieldFor = function(fieldType) {
        var typeMap = {
            // Other
            EMAIL: 'email',
            PASSWORD: 'password',
            TEXT: 'text',
            PHONE: 'tel',
            DATE: 'date',
            OPTIONS: 'options',
        }
        return typeMap[fieldType] || 'text';
    }

    upp.directive('customerFields', [ function () {
        return {
            restrict: 'E',
            scope: {
                fields: '=',
                values: '=',
                readonly: '=ngReadonly',
                onChange: '&?',
            },
            templateUrl: require('../templates/customer-fields.html'),
            controllerAs: '$ctrl',
            controller: CustomerFieldsController,
        };
    } ]);

}(upp, angular));


// WEBPACK FOOTER //
// ./src/app/modules/customer-account/component/customer-fields.component.js